'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';

export const nutritionModule = angular
  .module('app.nutrition', [])
  .config(nutritionConfig);

nutritionConfig.$inject = ['$routeProvider'];

function nutritionConfig($routeProvider) {
  $routeProvider
    .when('/compliance-board', {
      template: '<ngz-compliance-board></ngz-compliance-board>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [{ label: 'Compliance Board', icon: NAVIGATION_ICON.LIST_ALT }],
      },
    });
}
